import styled from "styled-components";
import background from "../assets/background.png";
import mask from "../assets/ring.png";
import { breakpoints } from "../styles/globalStyles";
import useMotionStore from "../store/MotionStore";
import "./main-layout.css";
import Footer from "../components/footer";

const MainLayout = ({ children }: any) => {
  const { motionLayout } = useMotionStore();
  return (
    <div className="mainLayout">
      <Container className="container">
        {/* <Mask src={mask} className="media-mask" /> */}
        {children}
        <Footer />
      </Container>
    </div>
  );
};

export default MainLayout;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  background-size: cover;
`;

const Mask = styled.img`
  position: absolute;
  width: 100%;
  bottom: 0;
  right: 0;
  z-index: -1;
`;

const CardContainer = styled.div`
  width: 70%;
  max-width: 1420px;
  border-radius: 10px;
  z-index: 1;
  background: white;

  @media screen and (max-width: ${breakpoints.sm}) {
    width: 90%;
    background: white;
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    width: 90%;
    
  }

  @media screen and (min-width: ${breakpoints.md} and (max-with: ${breakpoints.lg})) {
    width: 80%;
    background: white;
  }
    
  @media screen and (min-width: ${breakpoints.lg}) {
    width: 70%;
    background: white;
  }
`;

const LogoImage = styled.div`
  @media screen and (max-width: ${breakpoints.md}) {
    margin-top: 2rem !important;
  }
`;

const TermSentence = styled.div`
  align-items: center;
  text-align: center;
  margin-bottom: 2rem;
  margin-left: 1rem;
  margin-right: 1rem;
  color: #ffff;
`;

const ForgotPasswordLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
  margin-left: 3px;
  color: white;
`;

const Dot = styled.span`
  margin-left: 3px;
`;
